var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "dialog-bottom",
      attrs: { visible: _vm.editDialogConfig.visible, size: "900px" },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.editDialogConfig, "visible", $event)
        },
      },
    },
    [
      _c("div", { staticClass: "detailHead bdbtmSolid" }, [
        _c("div", { staticClass: "acea-row row-between headerBox" }, [
          _c("div", { staticClass: "full" }, [
            _c("div", { staticClass: "order_icon" }, [
              _c("span", { staticClass: "iconfont icon-shanghuliebiao" }),
            ]),
            _c("div", { staticClass: "text" }, [
              _c("div", { staticClass: "acea-row" }, [
                _c("div", { staticClass: "title mr10" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.editDialogConfig.isCreate === 0
                          ? "添加会员等级-LV" + _vm.form.level
                          : "编辑会员等级-LV" + _vm.form.level
                      ) +
                      " "
                  ),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [
                        "merchant:member:level:add",
                        "merchant:member:level:update",
                      ],
                      expression:
                        "['merchant:member:level:add', 'merchant:member:level:update']",
                    },
                    {
                      name: "debounceClick",
                      rawName: "v-debounceClick",
                      value: _vm.saveForm,
                      expression: "saveForm",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt20",
          attrs: { "label-width": "95px", model: _vm.form, rules: _vm.rules },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "等级名称：", prop: "name" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入等级名称",
                  size: "small",
                  clearable: "",
                  maxlength: "10",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm.form.level > 1
            ? _c(
                "el-form-item",
                { attrs: { label: "升级条件：", prop: "thresholdAmount" } },
                [
                  _c("span", { staticClass: "font12 color-606266" }, [
                    _vm._v("当消费金额累计达到 "),
                  ]),
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 999999,
                      type: "number",
                      controls: false,
                      precision: 2,
                      step: 0.01,
                      placeholder: "请输入金额",
                    },
                    model: {
                      value: _vm.form.thresholdAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "thresholdAmount", $$v)
                      },
                      expression: "form.thresholdAmount",
                    },
                  }),
                  _c("span", { staticClass: "font12 color-606266" }, [
                    _vm._v(" 元，可晋升为本等级。 "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "等级权益：", prop: "benefitsList" } },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.changeBenefits },
                  model: {
                    value: _vm.form.benefitsList,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "benefitsList", $$v)
                    },
                    expression: "form.benefitsList",
                  },
                },
                _vm._l(_vm.benefitOptions, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.id, attrs: { label: item.id } },
                    [_c("span", [_vm._v(_vm._s(item.name))])]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm.hasGiftBenefit
            ? _c(
                "el-form-item",
                { attrs: { label: "升级奖励：", prop: "couponIds" } },
                [
                  _c(
                    "div",
                    { staticClass: "reward-section" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.addCoupon },
                        },
                        [_vm._v("添加优惠券")]
                      ),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v(
                          "当用户达到此等级时，系统自动发送升级奖励中选中的优惠券。"
                        ),
                      ]),
                      _vm.tableData.data.length > 0
                        ? _c(
                            "div",
                            { staticClass: "coupon-list" },
                            [
                              _c("base-table", {
                                ref: "table",
                                attrs: {
                                  "table-data": _vm.tableData,
                                  columns: _vm.tableColumns,
                                  showPagination: false,
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", { staticClass: "no-coupon" }, [
                            _vm._v("暂无优惠券"),
                          ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }